/** Late work orders (LIAA service plan S2.5): my late orders, the reason, the extension. */

import type { WorkOrderCard } from '../types/workOrderTypes';

import { apiClient } from '@/shared/api/client';

export interface OverdueRow {
  id: string;
  number: string;
  vehicle: string | null;
  dueOn: string;
  daysLate: number;
  dueLate: boolean;
  statusId: string;
  statusHours: number | null;
  statusLimitHours: number | null;
  reason: string | null;
}

export async function fetchMyOverdue(): Promise<OverdueRow[]> {
  const { data } = await apiClient.get<{ workOrders: OverdueRow[] }>('/work-orders/my-overdue');
  return data.workOrders;
}

export async function setOverdueReason(id: string, reason: string | null): Promise<WorkOrderCard> {
  const { data } = await apiClient.post<{ workOrder: WorkOrderCard }>(`/work-orders/${id}/overdue-reason`, { reason });
  return data.workOrder;
}

export async function extendDue(id: string, input: { version: number; dueOn: string; reason: string }): Promise<WorkOrderCard> {
  const { data } = await apiClient.post<{ workOrder: WorkOrderCard }>(`/work-orders/${id}/extend`, input);
  return data.workOrder;
}
